import { getGroupedVendorHotlist, getBulkMailDetails, sendBulkMail } from '../../../../services/dropdownApi';

export const api = {
  getVendorList: ({ jobId, limit, offset, type }) =>
    getGroupedVendorHotlist({ jobId, limit, offset, sortBy: 'new', type }),

  getMailDetails: (jobId) => getBulkMailDetails(jobId),

  submit: ({ jobId, toMail, ccMail, bccMail, subject, contents }) =>
    sendBulkMail({ jobId, toMail, ccMail, bccMail, subject, contents }),
};
